import { render, staticRenderFns } from "./IngresoMunicion.vue?vue&type=template&id=173373e8"
import script from "./IngresoMunicion.vue?vue&type=script&lang=js"
export * from "./IngresoMunicion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports